import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=545ea82c&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=js&"
export * from "./TypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=545ea82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ea82c",
  null
  
)

export default component.exports